import * as React from 'react';
import { 
	ConnectedLoggedInUserName, 
	RepairCenterContentRoute,
	RCSignOut
} from '@mitchell/redux.module.apd';

export const UserNameMenuComponent = <ConnectedLoggedInUserName />;

export const Signout = (): JSX.Element => <RCSignOut/>;

export const DummyContent = (props: { content: string }): JSX.Element => {
	return <p>{props.content}</p>;
};

export const RepairCenter = (): JSX.Element => <RepairCenterContentRoute />;
